import { useRef, useState } from "react";
import { useRouter } from "next/router";
import { IoSearchOutline } from "react-icons/io5";
import LocationSearchPopover from "@/Component/Module/ActivityListing/LocationSearchPopover";
import LocationSearchScreen from "@/Component/Module/ActivityListing/LocationSearchScreen";
import useIsDesktop from "@/hooks/useIsDesktop";
import useBodyScrollLock from "@/hooks/useBodyScrollLock";
import { buildActivitySearchHref, getSearchDisplayLabel } from "@/utils/activitySearch";
import { withRegionPath } from "@/utils/session";
import { beginListingSearch } from "@/utils/listingFilterSession";
import styles from "./Header.module.css";

export default function ActivityHeaderSearch() {
  const router = useRouter();
  const inputWrapRef = useRef(null);
  const [query, setQuery] = useState("");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const { isDesktop, mounted } = useIsDesktop(900);

  useBodyScrollLock(mobileSearchOpen);

  const navigateToSelection = (item) => {
    if (!item) return;

    setQuery(getSearchDisplayLabel(item, item.label));
    setPopoverOpen(false);
    setMobileSearchOpen(false);
    beginListingSearch("activity");
    router.push(withRegionPath(buildActivitySearchHref(item)));
  };

  const openMobileSearch = () => {
    setPopoverOpen(false);
    setMobileSearchOpen(true);
  };

  const handleDesktopChange = (event) => {
    setQuery(event.target.value);
    setPopoverOpen(true);
  };

  const handleDesktopFocus = () => {
    setPopoverOpen(true);
  };

  const isMobileSearch = mounted && !isDesktop;

  return (
    <>
      <div className={styles.searchRow}>
        <div className={styles.inputWrap} ref={inputWrapRef}>
          <input
            className={styles.input}
            type="search"
            placeholder="Search Cities, Activities..."
            value={query}
            onChange={isMobileSearch ? undefined : handleDesktopChange}
            onFocus={isMobileSearch ? openMobileSearch : handleDesktopFocus}
            onClick={isMobileSearch ? openMobileSearch : undefined}
            readOnly={isMobileSearch}
            autoComplete="off"
            aria-label="Search activities"
            aria-expanded={popoverOpen || mobileSearchOpen}
            aria-haspopup="listbox"
          />
          <span className={styles.searchIcon} aria-hidden="true">
            <IoSearchOutline size={24} />
          </span>
          {mounted && isDesktop && popoverOpen ? (
            <LocationSearchPopover
              anchorRef={inputWrapRef}
              query={query}
              onClose={() => setPopoverOpen(false)}
              onSelect={navigateToSelection}
              className={styles.headerSearchPopover}
            />
          ) : null}
        </div>
      </div>

      {isMobileSearch && mobileSearchOpen ? (
        <LocationSearchScreen
          initialQuery={query}
          onClose={() => setMobileSearchOpen(false)}
          onSelect={navigateToSelection}
        />
      ) : null}
    </>
  );
}
